import { UniDriver } from '@wix/unidriver-core';
import { baseUniDriverFactory } from '../utils/test-utils/unidriver';
import { buttonDriverFactory } from '../Button/Button.uni.driver';

export const calendarPanelFooterDriverFactory = (base: UniDriver) => {
  const getByDataHook = (dataHook: string) => base.$(`[data-hook=${dataHook}]`);
  const getButton = (dataHook: string) => {
    const buttonElem = getByDataHook(dataHook);
    return buttonDriverFactory(buttonElem);
  };

  const primaryButtonDataHook = 'primary-action-button';
  const secondaryButtonDataHook = 'secondary-action-button';

  return {
    ...baseUniDriverFactory(base),
    isPrimaryButtonDisabled: () =>
      getButton(primaryButtonDataHook).isButtonDisabled(),
    getSelectedDaysText: () => getByDataHook('selected-days-text').text(),
    getPrimaryActionButtonLabel: () =>
      getButton(primaryButtonDataHook).getButtonTextContent(),
    getSecondaryActionButtonLabel: () =>
      getButton(secondaryButtonDataHook).getButtonTextContent(),
    clickOnPrimaryButton: () => getButton(primaryButtonDataHook).click(),
    clickOnSecondaryButton: () => getButton(secondaryButtonDataHook).click(),
  };
};

export type CalendarPanelFooterUniDriver = ReturnType<
  typeof calendarPanelFooterDriverFactory
>;
